import { render, staticRenderFns } from "./CsSolicitudesNacionalesPresupuesto.vue?vue&type=template&id=472e2387"
import script from "./CsSolicitudesNacionalesPresupuesto.vue?vue&type=script&lang=js"
export * from "./CsSolicitudesNacionalesPresupuesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports